import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatWorkshopSchedule, loadWorkshop2026Context, WORKSHOP_2026_PATH } from '../services/workshop2026Service';
import styles from '../styles/workshop2026MeetingsCard.module.css';

const Workshop2026MeetingsCard: React.FC = () => {
  const navigate = useNavigate();
  const [scheduleLine, setScheduleLine] = useState(formatWorkshopSchedule(null));

  useEffect(() => {
    let cancelled = false;
    loadWorkshop2026Context().then((ctx) => {
      if (!cancelled) {
        setScheduleLine(formatWorkshopSchedule(ctx.meeting));
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>2026 SAA Step Workshop</h2>
      <p className={styles.subtitle}>Personally work your SAA 12 steps in community with others · Online</p>
      <p className={styles.schedule}>{scheduleLine}</p>
      <button
        type="button"
        className={styles.cta}
        onClick={() => navigate(WORKSHOP_2026_PATH)}
      >
        Go to workshop home
      </button>
    </div>
  );
};

export default Workshop2026MeetingsCard;
